/**
 * This function fetch by regular expression the img tags src values from a string what contains html.
 * Return an array of strings of urls.
 * @param {string} html
 */
export const fetchSrcValuesFromHtml = (html) => {
    let srcValueList = []

    if (!html) {
        return srcValueList
    }

    const regexImgs = /<img(.*?)src=["'](.*?)["'](.*?)>/g
    const foundImgs = html.match(regexImgs)

    if (!foundImgs || foundImgs.length == 0) {
        return srcValueList
    }
    const regexSrc = /src=["'](.*?)["']/g
    let foundSrc = false

    foundImgs.forEach((oneImg)=>{
        foundSrc = oneImg.match(regexSrc)

        if (!foundSrc || foundSrc.length == 0) {
            return
        }

        let cleanUrl = foundSrc[0].substring(5, foundSrc[0].length - 1)
        srcValueList.push(cleanUrl)
    })

    return srcValueList
}



// WEBPACK FOOTER //
// ./components/emailSender/helpers.jsx